/**
 * sgWidgetContainerCtrl
 * version: 0.0.1
 *
 * TODO: create the widget functions (minimize)
 */

(function () {
  angular
    .module('specsguardApp')
    .controller('sgWidgetContainerCtrl', sgWidgetContainerCtrl);

  sgWidgetContainerCtrl.$inject = ['Labels', '$compile'];

  function sgWidgetContainerCtrl(Labels, $compile) {
    const vm = this;
    vm.LABELS = Labels;
  }
})();
